import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface QAErrorAlertProps {
  message: string;
  error?: string | null;
  onRetry?: () => void;
}

export const QAErrorAlert: React.FC<QAErrorAlertProps> = ({ message, error, onRetry }) => (
  <div className="p-4 bg-destructive/10 border border-destructive/30 rounded-lg my-4">
    <div className="flex items-start gap-3">
      <AlertTriangle className="h-5 w-5 text-red-500 mt-0.5" />
      <div className="flex-1">
        <p className="font-medium text-red-400">{message}</p>
        {error && <p className="text-sm text-red-400 mt-1">{error}</p>}
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  </div>
);
